<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZXJjP2/tc-custom/9781504057554.jpg?1737166238606" alt="This image is the cover for the book Inmate 1577 and No Way Out, The Karen Vail Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Inmate 1577 and No Way Out, The Karen Vail Novels
      </h1>
      <p class="bookDescription body article font2">
        <b>From the <i>USA Today</i>–bestselling author of <i>The 7th Victim</i>, books 4 and 5 in the FBI thriller series featuring “one of thrillerdom’s feistiest heroines” (Joseph Finder,<i> New York Times</i>–bestselling author of <i>The Switch</i>).</b><br/>  <br/> The survivor of abusive marriage, Special Agent Karen Vail has become hard and uncompromising in her work as the FBI’s lead profiler. Follow her now as she trails brutal killers across the country and then across the pond . . .<br/>  <br/><i>Inmate 1577</i>: When an elderly woman is found raped and murdered in San Francisco, Vail heads west to team up with SFPD inspector Lance Burden and her former task force colleague Det. Roxxann Dixon. As they chase the killer around the city, his rampage continues, leaving behind clues that lead them to Alcatraz Island, whose long-buried, decades-old secrets hold the key to their case . . .<br/>  <br/> “A powerful thriller, brilliantly conceived and written.” —Clive Cussler, <i>New York Times</i>–bestselling author of <i>Havana Storm</i><br/>  <br/><i>No Way Out</i>: After a massive bombing in London, Karen Vail is dispatched to England to work with the Scotland Yard on drafting a threat assessment to head off future attacks. Only, their work uncovers a trail leading to a centuries-old manuscript, the radicals bent on destroying it, and a rogue covert operative with explosive plans. Soon both assassins and British authorities are chasing the beleaguered FBI agent in a race for her life, and there’s no telling who will come out on top . . .<br/>  <br/> “Jacobson knows how to throw in plot twists that are shocking but logical.” —<i>Library Journal</i><br/>  <br/><b>Praise for Alan Jacobson</b><br/> “Karen Vail is as compelling a character as any created by Patricia Cornwell, or yours truly.” —James Patterson,<i> New York Times</i>–bestselling author
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alan Jacobson
      </h2>
      
      <p class="authorDescription body article">Alan Jacobson is the national bestselling author of the critically acclaimed FBI profiler Karen Vail and OPSIG Team Black series. Jacobson&rsquo;s years of extensive research and training while embedded with federal and local law enforcement agencies have influenced him both personally and professionally, and have helped shape the stories he tells and the diverse characters that populate his novels.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a1e3da44